<template>
    <FeaturesPageFeaturePanel icon="bwclockserver" :title="$t('pages.features.clockServerCard.title')"
                              :desc="$t('pages.features.clockServerCard.desc')">
        <ul class="clockServerFeaturesList">
            <li v-for="(i,index) in $t('pages.features.clockServerCard.featuresList')"
                :key="index">{{i}}
            </li>
        </ul>
        <div class="gallery-container">
            <ClockServerGallery/>
        </div>
    </FeaturesPageFeaturePanel>

</template>

<script>
    import FeaturesPageFeaturePanel from "./toolkit/FeaturesPageFeaturePanel";
    import ClockServerGallery from "./toolkit/ClockServerGallery";

    export default {
        name: "ClockServerFeature",
        components: {FeaturesPageFeaturePanel,ClockServerGallery}
    }
</script>

<style scoped lang="scss">
    @import "../../../theme/theme";

    ul > li {
        font-size: 0.9em;
        margin-bottom: 0.5em;
        text-align:justify;
        margin-right: 1em;
    }
    .gallery-container {
        display: grid;
        justify-items: center;
        padding-right: 1rem;
        margin-top: 1rem;
        margin-bottom: 1rem;
    }
</style>